import { useGetGeolocalizzazioneGruppiComuni } from '@framework/api-client/api/inquiries/geolocalizzazione-controller/geolocalizzazione-controller.ts';
import {
  type ISelectInputProps,
  SelectInput,
} from '@framework/form/inputs/SelectInput.tsx';

export interface IMunicipalityGroupListSelectInputProps
  extends ISelectInputProps {
  name: string;
}
export function MunicipalityGroupListSelectInput(
  props: IMunicipalityGroupListSelectInputProps,
) {
  const { name, ...otherProps } = props;

  const { data, isFetching, isLoading } = useGetGeolocalizzazioneGruppiComuni({
    query: {
      enabled: true,
    },
  });

  return (
    <SelectInput
      {...otherProps}
      name={name}
      loading={isFetching || isLoading}
      searchable
      mode="multiple"
      options={
        data?.map(group => ({
          value: group.codiceGruppo ?? undefined,
          label: group.denominazione,
        })) ?? []
      }
    />
  );
}
